export default {
  default: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/layouts/empty.vue").then(m => m.default || m)
}